/**
 * Permissions to be used as shared constants in the components app templates
 * and centralize changes on permissions name.
 * to use it:
 *  invoke this.$permissions
 *  ...
 */
const DELETE_DOMAIN = 'sys_admin:write_domains';
const VIEW_ORIGINATOR_GROUPS = 'users:read_originator_teams';
const VIEW_SENIOR_FUNDER_GROUPS = 'users:read_senior_funder_teams';
const ADD_USERS = 'sys_admin:write_users';
const EDIT_USERS = 'sys_admin:write_users';
const ADD_GROUPS = 'sys_admin:write_groups';
const EDIT_GROUPS = 'sys_admin:write_groups';
const DELETE_GROUPS = 'sys_admin:write_groups';
const ADD_PERMISSIONS = 'sys_admin:write_permissions';
const EDIT_PERMISSIONS = 'sys_admin:write_permissions';
const DELETE_PERMISSIONS = 'sys_admin:write_permissions';
const VIEW_USER_HISTORY = 'sys_admin:view_user_history';
const ADD_ROLES = 'sys_admin:create_roles';
const EDIT_ROLES = 'sys_admin:edit_roles';
const DELETE_ROLES = 'sys_admin:create_roles';
const ADD_ROLE_LEVELS = 'sys_admin:create_role_levels';
const DELETE_ROLE_LEVELS = 'sys_admin:create_role_levels';
const EDIT_ROLE_LEVELS = 'sys_admin:edit_role_levels';
const ADD_DOMAINS = 'sys_admin:write_domains';
const EDIT_DOMAINS = 'sys_admin:write_domains';
const DELETE_DOMAINS = 'sys_admin:write_domains';
const REMOVE_ORIGINATOR_TEAM_MEMBER = 'users:write_originator_teams';
const REMOVE_SENIOR_FUNDER_TEAM_MEMBER = 'users:write_senior_funder_teams';
const EDIT_ORIGINATOR_TEAM = 'users:write_originator_teams';
const EDIT_SENIOR_FUNDER_TEAM = 'users:write_senior_funder_teams';
// confirm this permission with the team;
const ADD_SIGNATURE_TO_USERS = 'users:write_originator_teams';


const VuePermissionsPlugin = {
  install(Vue) {
    if (!Object.prototype.hasOwnProperty.call(Vue, '$permissions')) {
      Object.defineProperty(Vue.prototype, '$permissions', {
        get: function get() {
          return {
            DELETE_DOMAIN,
            VIEW_ORIGINATOR_GROUPS,
            VIEW_SENIOR_FUNDER_GROUPS,
            ADD_USERS,
            EDIT_USERS,
            ADD_GROUPS,
            EDIT_GROUPS,
            DELETE_GROUPS,
            VIEW_USER_HISTORY,
            ADD_PERMISSIONS,
            EDIT_PERMISSIONS,
            DELETE_PERMISSIONS,
            ADD_ROLES,
            EDIT_ROLES,
            ADD_ROLE_LEVELS,
            EDIT_ROLE_LEVELS,
            DELETE_ROLE_LEVELS,
            DELETE_ROLES,
            ADD_DOMAINS,
            EDIT_DOMAINS,
            DELETE_DOMAINS,
            REMOVE_ORIGINATOR_TEAM_MEMBER,
            REMOVE_SENIOR_FUNDER_TEAM_MEMBER,
            EDIT_ORIGINATOR_TEAM,
            EDIT_SENIOR_FUNDER_TEAM,
            ADD_SIGNATURE_TO_USERS,
          };
        },
      });
    }
  },
};


export default VuePermissionsPlugin;
